var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2044 4.74473C47.3949 5.54653 45.4511 6.08828 43.4076 6.33316C45.5161 5.0715 47.0936 3.0858 47.8456 0.746578C45.8647 1.92325 43.6966 2.7515 41.4356 3.19531C39.9152 1.57192 37.9013 0.495911 35.7067 0.134339C33.5121 -0.227233 31.2595 0.145862 29.2986 1.1957C27.3378 2.24554 25.7784 3.91338 24.8626 5.94028C23.9467 7.96719 23.7257 10.2398 24.2338 12.4051C20.2198 12.2036 16.293 11.1603 12.7083 9.34294C9.12363 7.52558 5.96113 4.97479 3.42606 1.85609C2.55925 3.35134 2.06084 5.08495 2.06084 6.93126C2.05987 8.59335 2.46917 10.23 3.25243 11.696C4.0357 13.1619 5.16869 14.4119 6.5509 15.335C4.94791 15.284 3.38028 14.8508 1.97849 14.0716V14.2016C1.97833 16.5328 2.78469 18.7922 4.26076 20.5965C5.73683 22.4008 7.79168 23.6388 10.0766 24.1006C8.5896 24.503 7.03055 24.5623 5.51723 24.2739C6.16192 26.2797 7.4177 28.0338 9.10878 29.2904C10.7999 30.5471 12.8416 31.2434 14.9481 31.2821C11.3722 34.0892 6.95589 35.612 2.40973 35.6053C1.60442 35.6055 0.799796 35.5585 0 35.4644C4.61462 38.4314 9.98637 40.0061 15.4725 40C34.0439 40 44.1964 24.6185 44.1964 11.2783C44.1964 10.8449 44.1855 10.4072 44.166 9.97375C46.1408 8.54563 47.8455 6.77717 49.2 4.75123L49.2044 4.74473Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter.7726f80ad1a57727f0be8ddfd37658d2.svg";